module.exports = __webpack_public_path__ + "img/avatar0.7db2ac1d.png";